/**
 * Na Home (durante): quando a hora do resumo já passou, o card compacto de
 * hoje ("O dia de hoje está pronto"). Na Home (depois): o diário — um card
 * por dia, do último para o primeiro.
 */
import { featureEnabled } from '@nv/core';
import { Link } from 'react-router-dom';

import { useDiasDaViagem } from '../../trip/dias';
import { useTrip } from '../../trip/TripContext';
import { Icon } from '../../ui/icons';
import { SectionLabel } from '../../ui/primitives';
import { useResumoDoDia } from './api';
import { ResumoDoDiaCard } from './ResumoDoDiaCard';

export function ResumoDeHojeNaHome({ hoje }: { hoje: string | null }) {
  const { trip, tripId } = useTrip();
  const ligado = featureEnabled(trip.features, 'resumo_do_dia');
  const dias = useDiasDaViagem(tripId);
  const dayId = dias.days?.find((d) => d.date === hoje)?.id ?? null;
  const resumo = useResumoDoDia(tripId, dayId, ligado && !!hoje);
  if (!ligado || !resumo.data?.ready) return null;
  return <ResumoDoDiaCard resumo={resumo.data} compacto />;
}

const ddmm = (iso: string) => `${iso.slice(8, 10)}/${iso.slice(5, 7)}`;

export function DiarioDaViagem() {
  const { trip, tripId } = useTrip();
  const ligado = featureEnabled(trip.features, 'resumo_do_dia');
  const dias = useDiasDaViagem(tripId);
  if (!ligado || !dias.days || dias.days.length === 0) return null;
  const ordem = [...dias.days].sort((a, b) => (a.date < b.date ? 1 : -1));
  return (
    <>
      <SectionLabel>DIÁRIO DA VIAGEM</SectionLabel>
      <div className="resumo__diario" data-testid="diario">
        {ordem.map((d) => (
          <Link key={d.id} to={`/memorias/${d.date}`} className="card resumo__dia">
            <span className="rk__cat-icone"><Icon name="destaque" size={16} /></span>
            <span className="rk__linha-texto">
              <span className="rk__linha-nome">{ddmm(d.date)}{d.title ? ` · ${d.title}` : ''}</span>
              <span className="rk__linha-familia">{d.activityCount === 0 ? 'sem programação' : `${d.activityCount} ${d.activityCount === 1 ? 'atividade' : 'atividades'}`} · ver o resumo</span>
            </span>
            <Icon name="avancar" size={16} />
          </Link>
        ))}
      </div>
    </>
  );
}
